<template>
  <el-card>
    <template #header>
      <content-header/>
    </template>

    <search-form
      ref="searchForm"
      :fields="search"
    />

    <el-table
      :data="orders"
      class="font-class"
      resource="orders"
    >
      <el-table-column
        prop="no"
        align="center"
        label="订单号"
        show-overflow-tooltip
        min-width="120"
      />
      <el-table-column
        prop="area_name"
        align="center"
        label="区域"
        show-overflow-tooltip
        min-width="120"
      />
      <el-table-column
        prop="bike_no"
        align="center"
        label="车牌号"
        show-overflow-tooltip
        min-width="120"
      />

      <el-table-column
        prop="mobile"
        label="手机号"
        align="center"
        show-overflow-tooltip
        min-width="120"
      />
      <el-table-column
        prop="real_use_bike_time_length"
        align="center"
        min-width="100"
        show-overflow-tooltip
        label="骑行时长"
      />
      <el-table-column
        prop="pay_money"
        align="center"
        min-width="100"
        show-overflow-tooltip
        label="支付金额"
      />
      <el-table-column
        prop="pay_type_name"
        align="center"
        min-width="120"
        label="交易方式"
      >
        <template slot-scope="scope">
          <el-tag v-if="scope.row.pay_type==1">{{ scope.row.pay_type_name }}</el-tag>
          <el-tag
            v-else-if="scope.row.pay_type==0"
            type="info"
          >
            {{ scope.row.pay_type_name }}
          </el-tag>
          <el-tag
            v-else-if="scope.row.pay_type==2"
            type="warning"
          >
            {{ scope.row.pay_type_name }}
          </el-tag>
          <el-tag
            v-else
            type="success"
          >
            {{ scope.row.pay_type_name }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="orders_status"
        align="center"
        label="订单状态"
        min-width="100"
      >
        <template slot-scope="scope">
          <el-tag
            v-if="scope.row.status==3"
            type="success"
          >
            {{ scope.row.orders_status }}
          </el-tag>
          <el-tag
            v-else-if="scope.row.status==4"
            type="info"
          >
            {{ scope.row.orders_status }}
          </el-tag>
          <el-tag
            v-else
            type="danger"
          >
            {{ scope.row.orders_status }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="start_use_bike_time"
        label="开始时间"
        show-overflow-tooltip
        min-width="120"
      />
      <el-table-column
        prop="end_use_bike_time"
        label="结束时间"
        show-overflow-tooltip
        min-width="120"
      />
      <el-table-column
        prop="remark"
        label="备注"
        min-width="120"
      >
        <template #default="{ row }">
          <input-edit
            :id="row.id"
            field="remark"
            :update="updateOrders"
            v-model="row.remark"
          />
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        fixed="right"
        width="280"
      >
        <template slot-scope="scope">
          <el-button
            type="success"
            size="mini"
            @click="detailsClick(scope.row)"
          >
            详情
          </el-button>
          <el-button
            v-if="scope.row.status=='3' && scope.row.is_return"
            type="info"
            @click="returnMoneyClick(scope.row,scope.$index)"
            size="mini"
          >
            返还
          </el-button>
          <el-button
            v-else-if="scope.row.status=='2'"
            type="warning"
            @click="settlementMoneyClick(scope.row,scope.$index)"
            size="mini"
          >
            结算
          </el-button>

          <el-button
            v-show="scope.row.status=='0' || scope.row.status=='1' "
            type="danger"
            @click="ejectCloseBike(scope.row,scope.$index)"
            size="mini"
          >
            关锁
          </el-button>

          <el-button
            v-if="scope.row.status=='2' && scope.row.is_huisu"
            type="danger"
            @click="ejectReturnOrderBike(scope.row,scope.$index)"
            size="mini"
          >
            订单回溯
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog
      title="提示"
      :visible.sync="dialogCloseBikeVisible"
      width="30%"
    >
      <h2 style="color:red;">确认关闭此订单，并锁车吗</h2>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="dialogCloseBikeVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="closeOrderClick()"
        >确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="提示"
      :visible.sync="dialogReturnOrderBikeVisible"
      width="30%"
    >
      <h2 style="color:red;">确认回退此订单，改为骑车中吗</h2>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="dialogReturnOrderBikeVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="changeOrderRidingBike()"
        >确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="详情"
      :visible.sync="detailsDialogVisible"
      width="70%"
      top="5vh"
    >
      <div class="info-body">
        <div
          class="info-wrpp"
          style="width:25%;"
        >
          <p class="info-title">订单详情</p>
          <div class="info-item"><span>订单号：</span> <span>{{ order_no }}</span></div>
          <div class="info-item"><span>车牌号：</span> <span>{{ bike_no }}【{{ bike.battery_power }}%】</span></div>
          <div v-if="tianque_uuid" class="info-item"><span>天阙订单号：</span> <span>{{ tianque_uuid }}</span></div>
          <div v-if="tianque_sxfUuid" class="info-item"><span>落单号：</span> <span>{{ tianque_sxfUuid }}</span></div>
          <div class="info-item"><span>区域：</span> <span>{{ area }}</span></div>
          <div class="info-item">
            <span>手机号码：</span>
            <span
              class="mobile-link"
              :class="{ 'is-loading': userAuthInfoLoading }"
              @click="showUserAuthInfo"
            >{{ mobile }}</span><i
              class="mobile-eye"
              :class="userAuthInfoLoading ? 'el-icon-loading' : 'el-icon-view'"
              @click="showUserAuthInfo"
            />
          </div>
          <div class="info-item"><span>订单状态：</span> <span>{{ order_status }}</span></div>
          <div class="info-item"><span>创建时间：</span> <span>{{ start_use_time }}</span></div>
          <div class="info-item"><span>结束时间：</span> <span>{{ end_use_time }}</span></div>
        </div>
        <div
          class="info-wrpp"
          style="width:25%;"
        >
          <div class="info-title">结算信息</div>
          <div class="info-item"><span>结算方式：</span> <span>{{ settle_type }} </span></div>
          <div class="info-item"><span>骑行时长：</span> <span>{{ ridding_time_name }}</span></div>
          <div class="info-item"><span>骑行里程：</span> <span>{{ ridding_length }} 千米</span></div>
          <div class="info-item"><span>优惠方式：</span> <span>{{ preferential_type_name }} </span></div>
          <!-- <div class="info-item"><span>优惠券优惠：</span> <span>{{ is_coupon_name }} </span></div> -->
          <div class="info-item"><span>订单金额：</span> <span class="amount">{{ total_money }} </span></div>
          <div class="info-item">
            <span>实际支付：</span><span class="amount">{{ pay_money }}</span>元
            <div class="cost">
              <p class="resetwid"><span class="inline-span">骑行花费：</span><span class="amountt">{{ time_money }}</span> <span>元</span> </p>
              <p><span>非还车点调度费：</span> <span class="amountt">{{ dispatch_money }}</span> 元</p>
              <p><span>骑行卡优惠金额：</span> <span class="amountt">{{ card_preferential_money }}</span> 元</p>
              <p><span>优惠券优惠金额：</span> <span class="amountt">{{ coupon_preferential_money }}</span> 元</p>
              <p><span>总优惠金额：</span> <span class="amountt">{{ preferential_money }}</span> 元</p>
            </div>
          </div>
        </div>
        <div
          class="info-wrpp"
          style="width:28%"
        >
          <p class="info-title">操作车辆记录</p>
          <div
            class="table-class"
            style="height:300px;"
          >
            <el-table
              :data="tableData1"
              style="width: 100%"
            >
              <el-table-column
                prop="created_at"
                label="时间"
                align="center"
                width="180"
              />
              <el-table-column
                prop="name"
                label="操作"
                align="center"
                show-overflow-tooltip
              />
            </el-table>
          </div>
        </div>
        <div
          class="info-wrpp"
          style="width:16%;margin-right:0;"
        >
          <p class="info-title">车辆控制</p>
          <div
            class="table-class"
            style="height:300px;text-align:center;"
          >
            <p>
              <el-button
                type="success"
                @click="orderBikeContro(order_no,'huiDian')"
              >
                超出运营区域回电
              </el-button>
            </p>
            <p>
              <el-button
                type="warning"
                @click="orderBikeContro(order_no,'openLock')"
              >
                　　车辆开锁
              </el-button>
            </p>
            <p>
              <el-button
                type="danger"
                @click="orderHuiSu()"
              >
                电量过低订单回溯
              </el-button>
            </p>
            <p v-if="!pay_status">
              <el-button
                @click="resetOrderNo(order_id)"
                type="default"
              >
                重置订单号
              </el-button>
            </p>
          </div>
        </div>
        <div
          class="info-wrpp"
          style="width:32%"
        >
          <p class="info-title">订单消费记录</p>
          <div
            class="table-class"
            style="height:300px;"
          >
            <el-table
              :data="tableData2"
              style="width: 100%"
            >
              <el-table-column
                prop="created_at"
                label="时间"
                align="center"
                show-overflow-tooltip
              />
              <el-table-column
                prop="name"
                label="操作"
                align="center"
                width="150"
                show-overflow-tooltip
              />
              <el-table-column
                prop="status"
                label="状态"
                align="center"
                width="80"
              >
                <template slot-scope="scope">
                  <el-tag
                    v-if="scope.row.status ==1"
                    type="success"
                  >
                    成功
                  </el-tag>
                  <el-tag
                    v-else
                    type="danger"
                  >
                    失败
                  </el-tag>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <!--        <div-->
        <!--          class="info-wrpp"-->
        <!--          style="width:32%"-->
        <!--        >-->
        <!--          <p class="info-title">手机信息</p>-->
        <!--          <div-->
        <!--            class="table-class"-->
        <!--            style="height:300px;"-->
        <!--          >-->
        <!--            <el-table-->
        <!--              :data="tableData3"-->
        <!--              style="width: 100%"-->
        <!--            >-->
        <!--              <el-table-column-->
        <!--                prop="label"-->
        <!--                label="类型"-->
        <!--                align="center"-->
        <!--                width="150"-->
        <!--                show-overflow-tooltip-->
        <!--              />-->
        <!--              <el-table-column-->
        <!--                prop="value"-->
        <!--                label="数据值"-->
        <!--                align="center"-->
        <!--                show-overflow-tooltip-->
        <!--              />-->
        <!--            </el-table>-->
        <!--          </div>-->
        <!--        </div>-->
        <div
          class="info-wrpp"
          style="width:66%;margin-right:0;"
        >
          <p class="info-title">
            位置详情 <span
              class="info-huanche"
              v-show="is_whole_area_huanche"
            >(运营区域内均可还车)</span>
          </p>
          <div
            class="amap-page-container"
            style="width: 100%!important;"
          >
            <el-amap
              ref="map"
              vid="amapDemo"
              :amap-manager="amapManager"
              :center="center"
              :zoom="zoom"
              :plugin="plugin"
              :events="events"
              class="amap-demoo"
            >
              <el-amap-circle
                v-for="(circle,index) in circles"
                :key="'info2-'+index"
                :center="circle.center"
                :radius="circle.radius"
                :fill-opacity="circle.fillOpacity"
                :stroke-opacity="circle.strokeOpacity"
                :events="circle.events"
              />
              <el-amap-polygon
                v-for="(polygon, index) in polygons"
                :key="`parking_${index}`"
                :vid="index"
                :editable="false"
                :ref="`polygon_${index}`"
                :path="polygon.path"
                :z-index="40"
                :draggable="polygon.draggable"
                :fill-opacity="polygon.fillOpacity"
                :events="polygon.events"
              />
              <!-- <el-amap-circle
                    v-for="(circle,index) in banCircles"
                    :key="'info2S-'+index"
                    :center="circle.center"
                    :radius="circle.radius"
                    :fill-opacity="circle.fillOpacity"
                    :fill-color="circle.fillColor"
                    :stroke-color="circle.strokeColor"
                    :stroke-opacity="circle.strokeOpacity"
                    :events="circle.events"
                  /> -->
              <el-amap-polygon
                v-for="(polygon, index) in banPolygons"
                :key="`parkingS_${index}`"
                :vid="index"
                :editable="false"
                :ref="`polygonS_${index}`"
                :path="polygon.path"
                :z-index="40"
                :fill-color="polygon.fillColor"
                :draggable="polygon.draggable"
                :stroke-color="polygon.strokeColor"
                :fill-opacity="polygon.fillOpacity"
                :events="polygon.events"
              />
              <el-amap-polygon
                v-for="(polygon, index) in polygonsarea"
                :key="'infopolygonsarea-'+index"
                :vid="index"
                :ref="`polygon_${index}`"
                :path="polygon.path"
                :fill-opacity="polygon.fillOpacity"
                :draggable="polygon.draggable"
                :events="polygon.events"
              />
              <el-amap-marker
                :position="markerOrderPosition.position"
                :events="markerOrderPosition.events"
                :visible="markerOrderPosition.visible"
                :draggable="markerOrderPosition.draggable"
                :icon="markerOrderPosition.icon"
              />
              <el-amap-marker
                :position="markerBikePosition.position"
                :events="markerBikePosition.events"
                :visible="markerBikePosition.visible"
                :draggable="markerBikePosition.draggable"
                :animation="markerBikePosition.animation"
                :icon="markerBikePosition.icon"
              />
            </el-amap>
          </div>
        </div>
        <div
          class="info-wrpp"
          style="width:100%;margin-right:0;height:150px"
        >
          <p class="info-title">区域配置信息</p>
          <div
            class="table-class"
            style="padding-left:30px"
          >
            <p>
              骑行费用： 共享电单车在骑行中，<span v-show="isStart">起步价为<span class="span-red">{{ form.starting_price_time }}</span>分钟内<span class="span-red">{{ form.starting_price }}</span> 元，
                之后</span>
              每 <span class="span-red">{{ form.per_minute }}</span> 分钟收取 <span class="span-red">{{ form.per_money }}</span> 元费用，
            </p>
            <p>
              调度费用：当用户不在指定区域还车时，
              <span class="span-red">{{ form.min_limit_km }}</span>米内，另收 <span class="span-red">{{ form.min_dispatching_fee }}</span> 元调度费，<span class="span-red">{{ form.min_limit_km }}</span>米外，每增加<span class="span-red">{{ form.over_limit_per_km }}</span>米，多收取<span class="span-red">{{ form.over_limit_per_km_money }}</span>元
              最高封顶 <span class="span-red">{{ form.max_dispatching_fee }}</span> 元，
              <span class="p-green">注意：最高封顶为0元时，表示无封顶</span>
            </p>
          </div>
        </div>
      </div>
    </el-dialog>

    <el-dialog
      title="用户授权 / 手机信息"
      :visible.sync="userAuthInfoDialogVisible"
      width="680px"
      append-to-body
      custom-class="order-user-auth-dialog"
    >
      <div class="user-auth-panel">
        <div class="user-auth-summary">
          <div class="summary-item">
            <div class="summary-label">手机号码</div>
            <div class="summary-value">{{ userAuthInfo.mobile || '-' }}</div>
          </div>
          <div class="summary-item">
            <div class="summary-label">用户最近登录</div>
            <div class="summary-value">{{ userAuthInfo.last_login_time || '-' }}</div>
          </div>
          <div class="summary-item">
            <div class="summary-label">授权数量</div>
            <div class="summary-value">{{ userAuthInfo.auths.length }}</div>
          </div>
        </div>

        <div class="user-auth-section">
          <div class="section-head">
            <span class="section-title">微信 / 支付宝授权</span>
            <span class="section-tip">同一用户可能绑定多个微信，绿色标记为最近登录</span>
          </div>
          <el-table
            :data="userAuthInfo.auths"
            size="small"
            stripe
            empty-text="暂无授权信息"
            :row-class-name="authRowClassName"
          >
            <el-table-column
              label="类型"
              width="120"
              align="center"
            >
              <template slot-scope="scope">
                <el-tag
                  size="mini"
                  :type="scope.row.type === 0 ? '' : 'warning'"
                >
                  {{ scope.row.type_name }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column
              label="open_id"
              min-width="220"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <span class="openid-text">{{ scope.row.open_id || '-' }}</span>
                <el-tag
                  v-if="scope.row.is_last_login"
                  size="mini"
                  type="success"
                  style="margin-left: 8px;"
                >
                  最近登录
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column
              prop="authorized_at"
              label="授权时间"
              width="160"
              align="center"
              show-overflow-tooltip
            />
            <el-table-column
              label="操作"
              width="80"
              align="center"
            >
              <template slot-scope="scope">
                <el-button
                  type="text"
                  size="mini"
                  :disabled="!scope.row.open_id"
                  @click="copyOpenId(scope.row.open_id)"
                >
                  复制
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div class="user-auth-section">
          <div class="section-head">
            <span class="section-title">订单手机信息</span>
            <span class="section-tip">下单时记录的设备信息</span>
          </div>
          <el-table
            :data="userAuthInfo.phone_detail"
            size="small"
            stripe
            empty-text="暂无手机信息"
          >
            <el-table-column
              prop="label"
              label="类型"
              width="160"
              align="center"
              show-overflow-tooltip
            />
            <el-table-column
              prop="value"
              label="数据值"
              align="center"
              show-overflow-tooltip
            />
          </el-table>
        </div>
      </div>
    </el-dialog>

    <el-dialog
      title="返还"
      :visible.sync="returnDialogVisible"
      width="30%"
    >
      <div class="return-money">
        <p>
          <span> 返还骑行费用:</span>
          <el-input
            v-model="returnMoneyForm.ridding_money"
            @input="returnRiddingMoney"
            onkeyup="this.value=this.value.replace(/[^\d.]/g,'');"
            style="width:120px"
          />
          <span style="margin-left:20px">小等于￥{{ ke_return_time_money }}</span>
        </p>
        <p>
          <span> 返还调度费用:</span>
          <el-input
            v-model="returnMoneyForm.dispatch_money"
            @input="returnDispatchMoney"
            style="width:120px"
          /> <span style="margin-left:20px">小等于￥{{ dispatch_money }}</span>
        </p>
        <p>
          <span>
            选择返还方式：
          </span>
          <el-radio
            v-model="returnMoneyForm.return_type"
            label="wallet"
          >
            平台余额
          </el-radio>
          <el-radio
            v-model="returnMoneyForm.return_type"
            label="wechatANDalipay"
          >
            微信/支付宝
          </el-radio>
        </p>
        <p>
          <span>实际支付:</span> <span class="font-span"> {{ pay_money }}</span>
        </p>
      </div>

      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="returnDialogVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="submitReturnMoney"
        >确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="结算"
      :visible.sync="settlementDialogVisible"
      width="23%"
    >
      <div class="return-money">
        <p>
          <span> 骑行费用:</span>
          <el-input
            v-model="settlementMoneyForm.ridding_money"
            @input="settlementRiddingMoney"
            style="width:200px"
          />
        </p>
        <p>
          <span> 调度费用:</span>
          <el-input
            v-model="settlementMoneyForm.dispatch_money"
            @input="settlementDispatchMoney"
            style="width:200px"
          />
        </p>
        <p>
          <span> 优惠费用:</span>
          <el-input
            v-model="settlementMoneyForm.preferential_money"
            disabled
            style="width:200px"
          />
        </p>
        <p>
          <span>实际支付:</span> <span class="font-span"> {{ settlementMoneyForm.pay_money }}</span>
        </p>
      </div>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="settlementDialogVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="submitSettlementMoney"
        >确 定</el-button>
      </span>
    </el-dialog>
    <div class="card-footer">
      <pagination :page="page"/>
    </div>
  </el-card>
</template>

<script>
import SearchForm from '@c/SearchForm'
import Pagination from '@c/Pagination'
import {
  getOrders,
  getOrdersStatus,
  getOrderBikeOperate,
  settlementOrders,
  getOrderLocation,
  returnOrderMoney,
  closeLock,
  updateOrders,
  changeOrderRiding,
  orderDetailPosition,
  BikeControByOrder,
  resetOrderNo,
  getOrderUserAuthInfo,
} from '@/api/orders'
import { getAreas, showArea } from '@/api/area'
import VueAMap from 'vue-amap'
import { getParkings } from '@/api/parking'
import InputEdit from '@c/quick-edit/InputEdit'
import { mixinsAutoPageSize } from '@/libs/utils'
import { getAdminUsersMerchant } from '@/api/admin-merchant'
import env from '../../env'
export default {
  name: 'Index',
  components: {
    SearchForm,
    Pagination,
    InputEdit,
  },
  data() {
    let self = this
    let amapManager = new VueAMap.AMapManager()
    return {
      tableData1: [],
      tableData2: [],
      tableData3: [],
      search: [
        {
          type: 'el-select',
          field: 'area_id',
          label: '骑行区域',
          options: [
            {
              id: '',
              name: '全部',
            },
          ],
        },
        {
          type: 'el-select',
          field: 'status',
          label: '订单状态',
          options: [
            {
              id: '',
              name: '全部',
            },
          ],
        },
        {
          type: 'el-select',
          field: 'operate_status',
          label: '车辆操作状态',
          options: [
            {
              id: '',
              name: '全部',
            },
          ],
        },
        {
          type: 'super-input',
          field: 'mobile_nickname',
          label: '用户手机号',
        },
        {
          field: 'no',
          label: '订单号',
        },
        {
          field: 'bike_no',
          label: '车牌号',
        },
        {
          field: 'tianque_uuid',
          label: '天阙订单号',
        },
        {
          field: 'tianque_sxfUuid',
          label: '落单号',
        },
        {
          type: 'time-between',
          field: 'created_time_between',
          label1: '订单创建-开始',
          label2: '订单创建-结束',
        },
        {
          field: 'remark',
          label: '备注',
        },
        {
          type: 'el-select',
          field: 'is_dispatch_money',
          label: '是否有调度费',
          options: [
            {
              id: '',
              name: '全部',
            },
            {
              id: '1',
              name: '有调度费',
            },
            {
              id: '2',
              name: '无调度费',
            },
          ],
        },
        {
          type: 'el-select',
          field: 'is_refund_money',
          label: '是否返还费用',
          options: [
            {
              id: '',
              name: '全部',
            },
            {
              id: '1',
              name: '是',
            },
            {
              id: '0',
              name: '否',
            },
          ],
        },
      ],
      bike: {},
      orders: [],
      page: null,
      detailsDialogVisible: false,
      userAuthInfoDialogVisible: false,
      userAuthInfoLoading: false,
      userAuthInfo: {
        mobile: '',
        last_login_time: '',
        auths: [],
        phone_detail: [],
      },
      order_no: '',
      tianque_sxfUuid: '',
      tianque_uuid: '',
      order_id: '',
      bike_no: '',
      nickname: '',
      area: '',
      mobile: '',
      order_status: '',
      pay_status: true,
      start_use_time: '',
      time_money: '',
      end_use_time: '',
      real_use_bike_time_length: '',
      ridding_time: '',
      ridding_time_name: '',
      ridding_length: '',
      pay_money: '', // 实际支付金额
      total_money: '', // 订单金额
      pay_money_yun: '', // 实际支付金额
      sumDispatch: '', // 计算的调度差值
      ke_return_time_money: 0,
      dispatch_money: '',
      preferential_money: '',
      preferential_type_name: '', // 优惠方式
      is_coupon_name: '',
      card_preferential_money: 0.0,
      coupon_preferential_money: 0.0,
      returnDialogVisible: false,
      dialogCloseBikeVisible: false,
      dialogReturnOrderBikeVisible: false,
      is_whole_area_huanche: false, // 能否全大区还车
      row_order_id: '',
      settle_type: '',
      isStart: true,
      returnMoneyForm: {
        // 返还表单数据
        order_id: '',
        ridding_money: 0,
        dispatch_money: 0,
        return_type: 'wallet',
      },
      returnMoneyFormBool: false,
      settlementDialogVisible: false,
      settlementIndex: '',
      returnIndex: '',
      settlementMoneyForm: {
        // 结算表单数据
        order_id: '',
        ridding_money: 0,
        dispatch_money: 0,
        preferential_money: 0,
        pay_money: '',
      },
      form: {},
      zoom: 12,
      lng: 0,
      lat: 0,
      center: [121.59996, 31.197646],
      amapManager: amapManager,
      events: {
        init(o) {},
      },
      plugin: [
        {
          pName: 'MapType',
          defaultType: 0,
          events: {
            init(o) {
              // console.log(o)
            },
          },
        },
        {
          pName: 'Geolocation',
          events: {
            init(o) {
              // o 是高德地图定位插件实例
              // console.log(o)
              o.getCurrentPosition((status, result) => {
                // 未配置https  定位失败 暂时手动配置
                self.lng = 113.73350255780726
                self.lat = 34.78024666564106
                // self.center = [self.lng, self.lat]
                self.loaded = true
                if (this.isLoadOrderLocation) {
                  self.lng = this.center[0]
                  self.lat = this.center[1]
                  self.loaded = true
                  self.$nextTick()
                } else if (result && result.position) {
                  self.lng = result.position.lng
                  self.lat = result.position.lat
                  // self.center = [self.lng, self.lat]
                  self.loaded = true
                  self.$nextTick()
                }
              })
            },
          },
        },
        {
          pName: 'Scale',
          // offset: { x: 20, y: 20 },
          position: 'RB',
          events: {
            init(instance) {
              // console.log(instance)
            },
          },
        },
        {
          pName: 'ToolBar',
          events: {
            init(instance) {
              // console.log(instance)
            },
          },
        },
      ],
      markerOrderPosition: {
        position: [121.5273285, 31.21515044],
        events: {
          click: () => {
            // alert('click marker')
          },
        },
        visible: true,
        draggable: false,
        icon:
          'http://resource.bike.hanyiyun.com/admin/zhongdian20191203141105.png',
      },
      isLoadOrderLocation: false,
      markerBikePosition: {
        position: [121.5273285, 31.21515044],
        events: {
          click: () => {
            // alert('click marker')
          },
        },
        visible: true,
        draggable: false,
        animation: 'AMAP_ANIMATION_DROP',
        icon: 'http://resource.bike.hanyiyun.com/common/using.admin.png',
      },
      pathData: [],
      pathDataTimes: [],
      pathMarks: [],
      circles: [],
      polygons: [],
      banPolygons: [],
      banCircles: [],
      polygonsarea: [
        // 运营骑行区域
        {
          draggable: false,
          path: [],
          fillOpacity: 0.1,
          events: {
            click: () => {},
          },
        },
      ],
      first_blood: true,
    }
  },
  mixins: [mixinsAutoPageSize],
  watch: {
    $route: {
      async handler(newVal) {
        // console.log(this.$refs['SearchForm'].$el.offsetHeight)
        // eslint-disable-next-line promise/param-names
        // const sleep = t => new Promise(r => setTimeout(r, t))
        // let formHeight = 60
        // if (this.$refs.searchForm == undefined) {
        //   await sleep(0)
        //   formHeight = this.$refs.searchForm.$el.offsetHeight
        // } else {
        //   formHeight = this.$refs.searchForm.$el.offsetHeight
        // }
        // console.log(formHeight)
        // console.log(this.$refs.searchForm.$el.offsetHeight)
        await this.autoPageSize(49, newVal)
        const {
          data: { data, meta },
        } = await getOrders(newVal.query)
        this.orders = data
        this.page = meta
      },
      immediate: true,
    },
  },
  inject: ['reload'],
  async created() {
    const [{ data: areas }, { data: orderStatus }] = await Promise.all([
      getAreas({ all: 1 }),
      getOrdersStatus(),
    ])
    this.search[0].options.push.apply(this.search[0].options, areas)
    this.search[1].options.push.apply(
      this.search[1].options,
      orderStatus.order_status
    )
    this.search[2].options.push.apply(
      this.search[2].options,
      orderStatus.order_operate_status
    )
    // console.log(this.$refs.searchForm.$el.offsetHeight)
    if (this.$store.state.users.user.roles[0] === 'administrator') {
      const [{ data: merchant }] = await Promise.all([
        getAdminUsersMerchant({ all: 1 }),
      ])
      if (env.isPosSwitch == true) {
        this.search.push({
          type: 'el-select',
          field: 'merchant_id',
          label: '商户',
          options: [
            {
              id: '',
              name: '全部',
            },
          ],
        })
        this.search[9].options.push.apply(
          this.search[9].options,
          merchant.data
        )
      }
    }
  },
  updated() {},
  methods: {
    updateOrders,
    async showUserAuthInfo() {
      if (!this.order_id) {
        this.$message.warning('订单信息缺失')
        return
      }
      this.userAuthInfoLoading = true
      try {
        const { data } = await getOrderUserAuthInfo({ order_id: this.order_id })
        this.userAuthInfo = {
          mobile: data.mobile || '',
          last_login_time: data.last_login_time || '',
          auths: Array.isArray(data.auths) ? data.auths : [],
          phone_detail: Array.isArray(data.phone_detail) ? data.phone_detail : [],
        }
        this.userAuthInfoDialogVisible = true
      } catch (e) {
        // axios 拦截器已提示错误
      } finally {
        this.userAuthInfoLoading = false
      }
    },
    authRowClassName({ row }) {
      return row.is_last_login ? 'auth-row-last-login' : ''
    },
    copyOpenId(openId) {
      if (!openId) return
      const input = document.createElement('input')
      input.value = openId
      document.body.appendChild(input)
      input.select()
      try {
        document.execCommand('copy')
        this.$message.success('已复制 open_id')
      } catch (e) {
        this.$message.error('复制失败')
      }
      document.body.removeChild(input)
    },
    async detailsClick(row) {
      // 订单详情
      this.detailsDialogVisible = true
      this.order_no = row.no
      this.tianque_uuid = row.tianque_uuid
      this.tianque_sxfUuid = row.tianque_sxfUuid
      this.order_id = row.id
      this.bike_no = row.bike_no
      this.nickname = row.nickname
      this.area = row.area_name
      this.mobile = row.mobile
      this.order_status = row.orders_status
      this.start_use_time = row.start_use_bike_time
      this.end_use_time = row.end_use_bike_time
      this.pay_money = row.pay_money
      this.total_money = row.total_money
      this.time_money = row.time_money
      this.is_coupon_name = row.is_coupon_name
      this.dispatch_money = row.dispatch_money
      this.card_preferential_money = row.card_preferential_money
      this.coupon_preferential_money = row.coupon_preferential_money
      this.preferential_money = row.preferential_money
      this.preferential_type_name = row.preferential_type_name
      this.ridding_time_name = row.real_use_bike_time_length_name
      this.ridding_length = row.use_bike_distance_length
      this.settle_type = row.settle_type
      this.pay_status = row.pay_status

      if (row.phone_detail != '') {
        this.tableData3 = JSON.parse(row.phone_detail)
      } else {
        this.tableData3 = []
      }
      const { data: orderBikeOperate } = await getOrderBikeOperate({
        order_id: row.id,
      })
      this.tableData1 = orderBikeOperate.orderBikeOperate
      this.tableData2 = orderBikeOperate.walletLog
      this.bike = orderBikeOperate.bike
      // console.log(orderBikeOperate)
      const { data: orderPositions } = await orderDetailPosition({
        order_id: row.id,
      })

      this.markerOrderPosition.position = orderPositions.orderPosition
      this.markerBikePosition.position = orderPositions.bikePosition
      this.is_whole_area_huanche = orderPositions.is_whole_area_huanche
      this.center = orderPositions.orderPosition
      this.isLoadOrderLocation = true

      this.initParking(row.area_id)

      const [{ data }] = await Promise.all([
        getOrderLocation({ order_id: row.id }),
      ])
      let _this = this
      let OrderLocation = data.orderLocations
      this.pathDataTimes = data.locationsTimes
      if (OrderLocation.length == 0) {
        this.pathMarks = []
        this.$message('此订单暂无轨迹')
        if (window.pathSimplifierIns) {
          pathSimplifierIns.setData([])
          pathSimplifierIns.clearPathNavigators()
        }
      } else {
        let i = parseInt(OrderLocation.length / 2)
        // console.log(i)
        let centre = OrderLocation[i]
        // this.center = centre
        this.zoom = 19
        this.pathData = OrderLocation
        this.pathMarks = []

        if (window.pathSimplifierIns) {
          // 去除轨迹
          pathSimplifierIns.setData([])

          // 去除巡航器
          pathSimplifierIns.clearPathNavigators()
        }
        AMapUI.load(['ui/misc/PathSimplifier'], function (PathSimplifier) {
          if (!PathSimplifier.supportCanvas) {
            alert('当前环境不支持 Canvas！')
            return
          }

          // 启动页面
          _this.initPage(PathSimplifier)
        })
      }
    },
    fillForm(data) {
      this.form.id = data.id
      this.form.per_minute = data.per_minute
      this.form.per_money = data.per_money
      this.form.min_dispatching_fee = data.min_dispatching_fee
      this.form.max_dispatching_fee = data.max_dispatching_fee
      this.form.power_lower = data.power_lower
      this.form.is_parking = data.is_parking.toString()
      this.form.is_advance_recharge = data.is_advance_recharge.toString()
      this.form.is_whole_area_huanche = data.is_whole_area_huanche.toString()
      this.form.is_parking_fushe = data.is_parking_fushe.toString()
      this.form.is_deposit = data.is_deposit.toString()
      this.form.deposit = data.deposit
      this.form.is_auto_return_deposit = data.is_auto_return_deposit.toString()
      this.form.is_open_day_rent = data.is_open_day_rent.toString()
      this.form.is_return_deposit_ad_video = data.is_return_deposit_ad_video.toString()
      this.form.day_rent_money = data.day_rent_money
      this.form.day_rent_hours = data.day_rent_hours
      this.form.per_hours_day_rent_timeout_money =
        data.per_hours_day_rent_timeout_money
      this.form.day_rent_capping_money = data.day_rent_capping_money
      this.form.day_rent_img = data.day_rent_img
      this.form.over_limit_per_km = data.over_limit_per_km
      this.form.min_limit_km = data.min_limit_km
      this.form.over_limit_per_km_money = data.over_limit_per_km_money
      this.form.many_minute_free = data.many_minute_free
      this.form.minute_free_times = data.minute_free_times
      this.form.is_minute_free = data.is_minute_free.toString()
      this.form.starting_price_time = data.starting_price_time
      this.form.starting_price = data.starting_price
      // if (
      //   this.form.starting_price_time / this.form.starting_price ==
      //   this.form.per_minute / this.form.per_money
      // ) {
      //   this.isStart = false;
      // } else {
      //   this.isStart = true;
      // }
    },
    async initParking(areaId) {
      // 渲染骑行区
      const [{ data: darea }] = await Promise.all([showArea(areaId)])
      // this.center = JSON.parse(darea.area_centre)
      // this.zoom = 15
      this.fillForm(darea.areaSetting)
      var is_parking_fushe = darea.areaSetting.is_parking_fushe
      this.polygonsarea[0].path = JSON.parse(darea.area_fence)
      // 取出此区域的停车区
      const [{ data }] = await Promise.all([
        getParkings({ type: 2, area_id: areaId, status: 1 }),
      ])
      let polygons = []
      let circles = []
      var datas = data // 所有停车区遍历显示
      datas.forEach((item, i) => {
        item.parking_centre = JSON.parse(item.parking_centre)

        polygons.push({
          draggable: false,
          strokeOpacity: 0.1,
          fillOpacity: 0.1,
          path: item.parking_fence,
          events: {
            change: () => {},
            click: () => {},
          },
        })

        circles.push({
          center: item.parking_centre,
          radius: item.parking_radius,
          fillOpacity: 0.1,
          events: {
            click: () => {
              // alert('click')
            },
          },
        })
      })
      if (is_parking_fushe == 1) {
        this.circles = circles
      }

      this.polygons = polygons
      // 取出此区域的禁停车区
      const [{ data: banData }] = await Promise.all([
        getParkings({ type: 1, area_id: areaId, status: 1 }),
      ])
      let banPolygons = []
      let banCircles = []
      var BanDatas = banData // 所有停车区遍历显示
      BanDatas.forEach((item, i) => {
        item.parking_centre = JSON.parse(item.parking_centre)

        banPolygons.push({
          draggable: false,
          strokeOpacity: 0.1,
          fillOpacity: 0.3,
          fillColor: 'red',
          strokeColor: 'red',
          path: item.parking_fence,
          events: {
            change: () => {},
            click: () => {},
          },
        })

        banCircles.push({
          center: item.parking_centre,
          radius: item.parking_radius,
          fillOpacity: 0.3,
          fillColor: 'red',
          strokeColor: 'red',
          events: {
            click: () => {
              // alert('click')
            },
          },
        })
      })
      this.banCircles = banCircles
      this.banPolygons = banPolygons
    },
    initPage(PathSimplifier) {
      let _this = this
      // 创建组件实例
      var pathSimplifierIns = new PathSimplifier({
        zIndex: 100,
        map: this.amapManager._map, // 所属的地图实例
        autoSetFitView: false,
        getPath: function (pathData, pathIndex) {
          // 返回轨迹数据中的节点坐标信息，[AMap.LngLat, AMap.LngLat...] 或者 [[lng|number,lat|number],...]
          return pathData.path
        },
        getHoverTitle: function (pathData, pathIndex, pointIndex) {
          // console.log(_this.pathDataTimes)
          // 返回鼠标悬停时显示的信息
          if (pointIndex >= 0) {
            // 鼠标悬停在某个轨迹节点上
            return (
              pathData.name +
              '，点:' +
              pointIndex +
              '/' +
              pathData.path.length +
              ',时间：' +
              _this.pathDataTimes[pointIndex]
            )
          }
          // 鼠标悬停在节点之间的连线上
          return pathData.name + '，点数量' + pathData.path.length
        },
        renderOptions: {
          // 轨迹线的样式
          pathLineStyle: {
            strokeStyle: 'red',
            lineWidth: 2,
            dirArrowStyle: true,
          },
          renderAllPointsIfNumberBelow: 100,
        },
      })
      pathSimplifierIns.renderLater([{ delay: 1000 }])
      window.pathSimplifierIns = pathSimplifierIns

      // 这里构建两条简单的轨迹，仅作示例
      pathSimplifierIns.setData([
        {
          name: '轨迹',
          path: this.pathData,
        },
      ])

      // 创建一个巡航器
      var navg0 = pathSimplifierIns.createPathNavigator(
        0, // 关联第1条轨迹
        {
          loop: true, // 循环播放
          speed: 500,
        }
      )

      navg0.start()
    },
    ejectReturnOrderBike(row, index) {
      this.row_order_id = row.id
      this.dialogReturnOrderBikeVisible = true
    },
    async changeOrderRidingBike() {
      await changeOrderRiding({ order_id: this.row_order_id }).then(res => {
        res.then(data => {
          if (data) {
            this.$message({
              message: '操作成功',
              type: 'success',
            })
            this.reload()
            this.dialogReturnOrderBikeVisible = false
          }
        })
      })
    },
    returnMoneyClick(row, index) {
      // 点击返还事件
      this.returnIndex = index
      this.returnDialogVisible = true
      this.pay_money = row.pay_money
      this.pay_money_yun = row.pay_money // 实际支付金额
      this.ke_return_time_money = row.pay_money - row.dispatch_money

      this.time_money = row.time_money
      this.dispatch_money = row.dispatch_money
      // 初始化返还表单数据
      this.returnMoneyForm.ridding_money = 0
      this.returnMoneyForm.dispatch_money = 0
      this.returnMoneyForm.order_id = row.id
    },
    settlementMoneyClick(row, index) {
      // 结算点击事件
      this.settlementIndex = index
      this.settlementDialogVisible = true
      this.settlementMoneyForm.pay_money = Number(row.pay_money)
      this.settlementMoneyForm.dispatch_money = Number(row.dispatch_money)
      this.settlementMoneyForm.ridding_money = Number(row.time_money)
      this.settlementMoneyForm.preferential_money = Number(
        row.preferential_money
      )
      this.settlementMoneyForm.order_id = row.id
    },
    ejectCloseBike(row, index) {
      this.row_order_id = row.id
      this.dialogCloseBikeVisible = true
      // console.log(this.row_order_id)
    },
    async closeOrderClick() {
      await closeLock({ order_id: this.row_order_id }).then(res => {
        res.then(data => {
          if (data) {
            this.$message({
              message: '操作成功',
              type: 'success',
            })
            this.reload()
            this.dialogCloseBikeVisible = false
          }
        })
      })
    },
    returnRiddingMoney() {
      // 返还骑行金额输入事件
      this.pay_money =
        this.pay_money_yun -
        this.returnMoneyForm.ridding_money -
        this.returnMoneyForm.dispatch_money
      if (this.pay_money < 0) {
        this.$message({
          message: '返还骑行金额不能大于实际支付金额',
          type: 'warning',
        })
      }
    },
    returnDispatchMoney() {
      //  返还调度金额输入事件
      this.pay_money =
        this.pay_money_yun -
        this.returnMoneyForm.dispatch_money -
        this.returnMoneyForm.ridding_money
      //   if (this.pay_money < 0) {
      //     this.$message({
      //       message: '返还调度金额不能大于实际支付金额',
      //       type: 'warning',
      //     })
      //   }
      this.sumDispatch =
        this.dispatch_money - this.returnMoneyForm.dispatch_money
      if (this.sumDispatch < 0) {
        this.$message({
          message: '返还调度金额不能大于' + this.dispatch_money,
          type: 'warning',
        })
      }
    },
    async submitReturnMoney() {
      // 提交返还表单
      if (this.pay_money < 0) {
        this.$message({
          message: '返还金额不能大于实际支付金额',
          type: 'warning',
        })
      } else if (this.sumDispatch < 0) {
        this.$message({
          message: '返还调度金额不能大于' + this.dispatch_money,
          type: 'warning',
        })
      } else {
        this.returnMoneyFormBool = true
      }
      if (this.returnMoneyFormBool) {
        await returnOrderMoney(this.returnMoneyForm).then(res => {
          res.then(data => {
            if (data) {
              this.$message({
                message: '操作成功',
                type: 'success',
              })
              this.orders[this.returnIndex].pay_money = this.pay_money
            }
          })
        })
        this.returnDialogVisible = false
      }
    },
    settlementRiddingMoney() {
      // 输入结算骑行费用事件
      this.settlementMoneyForm.pay_money =
        Number(this.settlementMoneyForm.ridding_money) +
        Number(this.settlementMoneyForm.dispatch_money) -
        Number(this.settlementMoneyForm.preferential_money)
      this.settlementMoneyForm.pay_money =
        this.settlementMoneyForm.pay_money < 0
          ? 0
          : this.settlementMoneyForm.pay_money
    },
    settlementDispatchMoney() {
      // 输入结算调度费用事件
      this.settlementMoneyForm.pay_money =
        Number(this.settlementMoneyForm.ridding_money) +
        Number(this.settlementMoneyForm.dispatch_money) -
        Number(this.settlementMoneyForm.preferential_money)
      this.settlementMoneyForm.pay_money =
        this.settlementMoneyForm.pay_money < 0
          ? 0
          : this.settlementMoneyForm.pay_money
    },

    async submitSettlementMoney() {
      // 提交结算表单
      await settlementOrders(this.settlementMoneyForm).then(res => {
        res.then(data => {
          if (data) {
            this.$message({
              message: '操作成功',
              type: 'success',
            })
            this.orders[this.settlementIndex].status = 3
            this.orders[this.settlementIndex].orders_status = '已完成'
            this.reload()
          }
        })
      })
      this.orders[this.settlementIndex].pay_money = parseFloat(
        this.settlementMoneyForm.pay_money
      )
      this.orders[this.settlementIndex].dispatch_money = parseFloat(
        this.settlementMoneyForm.dispatch_money
      )
      this.orders[this.settlementIndex].time_money = parseFloat(
        this.settlementMoneyForm.ridding_money
      )
      this.settlementDialogVisible = false
    },
    async orderBikeContro(no, type) {
      // console.log(no)
      // console.log(type)

      await BikeControByOrder({ order_no: no, type: type }).then(res => {
        res.then(data => {
          if (data) {
            this.$message({
              message: '操作成功',
              type: 'success',
            })
            this.reload()
          }
        })
      })
    },
    async resetOrderNo(id) {
      await resetOrderNo({ id: id }).then(res => {
        res.then(data => {
          if (data) {
            this.$message({
              message: '操作成功',
              type: 'success',
            })
            this.reload()
          }
        })
      })
    },
    async orderHuiSu() {
      // 低电量订单回溯
      await changeOrderRiding({
        order_id: this.order_id,
        is_low_electric: true,
      }).then(res => {
        res.then(data => {
          if (data) {
            this.$message({
              message: '操作成功',
              type: 'success',
            })
            this.reload()
            this.dialogReturnOrderBikeVisible = false
          }
        })
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.font-class {
  font-size: 12px;
  text-align: center;
}
.info-body {
  color: #606266;
  width: 100%;
  font-size: 14px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  .info-wrpp {
    width: 47%;
    margin: 10px 10px 20px 0;
    padding-bottom: 10px;
    background-color: #eee;
    .info-item {
      margin-bottom: 10px;
      :first-child {
        display: inline-block;
        width: 100px;
        text-align: right;
      }
      span :last-child {
        padding-left: 10px;
      }
      .amount {
        font-size: 18px;
        color: coral;
        margin-right: 5px;
      }
      .amountt {
        color: coral;
      }
      .mobile-link {
        color: #409eff;
        cursor: pointer;
        font-weight: 600;
        text-decoration: underline;
        &:hover,
        & + .mobile-eye:hover {
          color: #66b1ff;
        }
        &.is-loading {
          color: #a0cfff;
          pointer-events: none;
        }
      }
      i.mobile-eye {
        color: #409eff;
        cursor: pointer;
        margin-left: 4px;
        width: auto !important;
        display: inline !important;
        text-align: left !important;
        padding-left: 0 !important;
        vertical-align: baseline;
        font-size: 14px;
      }
      .cost {
        padding-left: 102px;
        padding-top: 8px;
        .resetwid {
          width: auto;
        }
        p {
          margin: 0;
          .inline-span {
            display: inline;
          }
          span {
            display: inline;
          }
        }
      }
    }
  }
}
.info-title {
  font-weight: 700;
  font-size: 16px;
  margin: 20px 0 20px;
  padding-left: 10px;
  color: #606266;

  .info-huanche {
    color: red;
    font-size: 13px;
  }
}
.table-class {
  margin: 10px;
  height: 300px;
  overflow: auto;
}
.return-money {
  margin: 10px auto 10px 30px;
  p {
    margin-bottom: 20px;
    span:first-child {
      display: inline-block;
      text-align: right;
      margin: 10px 10px;
      font-size: 16px;
      color: #606266;
      font-weight: 700;
    }
    .font-span {
      padding-left: 30px;
      font-size: 18px;
      color: blue;
      font-weight: 700;
    }
  }
}
.span-red {
  color: red;
  padding-left: 3px;
  padding-right: 3px;
}
.amap-demoo {
  height: 350px !important;
  margin: auto 10px !important;
}
.el-dialog__body {
  padding: 3px 20px;
  color: #606266;
  font-size: 14px;
  word-break: break-all;
}

.user-auth-panel {
  padding: 4px 2px 8px;
}
.user-auth-summary {
  display: flex;
  gap: 12px;
  margin-bottom: 18px;
}
.summary-item {
  flex: 1;
  background: linear-gradient(180deg, #f7f9fc 0%, #eef3f9 100%);
  border: 1px solid #e4ebf3;
  border-radius: 8px;
  padding: 12px 14px;
}
.summary-label {
  font-size: 12px;
  color: #909399;
  margin-bottom: 6px;
}
.summary-value {
  font-size: 15px;
  color: #303133;
  font-weight: 600;
  word-break: break-all;
}
.user-auth-section {
  margin-bottom: 16px;
}
.section-head {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  margin-bottom: 10px;
}
.section-title {
  font-size: 14px;
  font-weight: 600;
  color: #303133;
}
.section-tip {
  font-size: 12px;
  color: #909399;
}
.openid-text {
  font-family: Menlo, Monaco, Consolas, 'Courier New', monospace;
  font-size: 12px;
  color: #303133;
}
</style>

<style lang="scss">
.order-user-auth-dialog {
  border-radius: 10px;
  overflow: hidden;
  .el-dialog__header {
    padding: 16px 20px 10px;
    border-bottom: 1px solid #eef0f4;
  }
  .el-dialog__title {
    font-size: 16px;
    font-weight: 600;
  }
  .el-dialog__body {
    padding: 16px 20px 20px;
  }
  .auth-row-last-login > td {
    background: #f0f9eb !important;
  }
}
</style>
